var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('n-link',{staticClass:"emp-hdr-masthead",attrs:{"title":_vm.title,"to":_vm.linkPath}},[_c('svg-moovup-logo',{staticClass:"emp-hdr-masthead__logo"}),_vm._v(" "),_c('h2',{staticClass:"emp-hdr-masthead__text"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }